<template>
  <div class="PageAppointmentRecordDetails m-wp-100 m-hp-100 m-hidden m-fb-col">
    <div class="m-p-16 scroll-box m-item-flex-1">
      <div class="m-bg-FFFFFF m-border-radius-16 m-mb-12 top-box">
        <img :src="statusType[appointmentDetail.status]" alt="" class="status-img" />
        <p class="m-p-16 title m-c-191A26-40">预约人信息</p>
        <div class="m-p-16">
          <template v-if="appointmentDetail.reserverInfoDto">
            <p class="m-c-191A26-60">预约人</p>
            <div class="m-mt-8 m-font-18">
              {{ appointmentDetail.reserverInfoDto.userName }}
              <span v-if="appointmentDetail.reserverInfoDto.memberJobNum"
                >（{{ appointmentDetail.reserverInfoDto.memberJobNum }}）</span
              >
            </div>
            <UTransition>
              <div v-show="showDetail">
                <p class="m-c-191A26-60 m-mt-16" v-if="appointmentDetail.reserverInfoDto.userDeptName">预约人单位</p>
                <div class="m-mt-8 m-font-18">
                  {{ appointmentDetail.reserverInfoDto.userDeptName }}
                </div>
                <p class="m-c-191A26-60 m-mt-16" v-if="appointmentDetail.reserverInfoDto.email">邮箱</p>
                <div class="m-mt-8 m-font-18">
                  {{ appointmentDetail.reserverInfoDto.email }}
                </div>
                <p class="m-c-191A26-60 m-mt-16" v-if="appointmentDetail.reserverInfoDto.phone">联系方式</p>
                <div class="m-mt-8 m-font-18">
                  {{ appointmentDetail.reserverInfoDto.phone }}
                </div>
              </div>
            </UTransition>
            <div @click="showDetail = !showDetail" class="m-c-003F88 m-mt-8">
              {{ showDetail ? '收起' : '更多信息' }}
            </div>
          </template>
        </div>
      </div>
      <div class="m-bg-FFFFFF m-border-radius-16 m-mb-12">
        <p class="m-p-16 title m-c-191A26-40">预约信息</p>
        <div class="m-p-16">
          <template v-if="appointmentDetail.reserveTime">
            <p class="m-c-191A26-60">预约时间</p>
            <div class="m-mt-8 m-font-18" v-html="computedShowTime"></div>
          </template>
          <!-- 预约地点 -->
          <template v-if="appointmentDetail.resourcePosition">
            <p class="m-c-191A26-60 m-mt-16">预约地点</p>
            <div class="m-mt-8 m-font-18">{{ appointmentDetail.resourcePosition }}</div>
            <div class="m-c-003F88 m-mt-8" @click="handlerToDetail" v-if="appointmentDetail.resourceAuthority">
              查看详情
            </div>
          </template>

          <p class="m-c-191A26-60 m-mt-16">活动类型</p>
          <div class="m-mt-8 m-font-18">{{ appointmentDetail.reserveType }}</div>
          <p class="m-c-191A26-60 m-mt-16">活动名称</p>
          <div class="m-mt-8 m-font-18">{{ appointmentDetail.activityName }}</div>
          <template v-if="computedMemberName">
            <p class="m-c-191A26-60 m-mt-16">参与人</p>
            <div class="m-mt-8 m-font-18">{{ computedMemberName }}</div>
          </template>
          <template v-if="appointmentDetail.memo">
            <p class="m-c-191A26-60 m-mt-16">备注</p>
            <div class="m-mt-8 m-font-18 word-break-all">
              {{ appointmentDetail.memo }}
            </div>
          </template>
          <template v-if="appointmentDetail.enclosure && appointmentDetail.enclosure.picUrl">
            <p class="m-c-191A26-60 m-mt-16">附件</p>
            <div class="m-mt-8 word-break-all">
              {{ appointmentDetail.enclosure.fileName }}
            </div>
            <div class="m-c-003F88" @click="handlerDownloadenClosure(appointmentDetail.enclosure)">下载</div>
          </template>
        </div>
      </div>
      <div class="m-bg-FFFFFF m-border-radius-16 m-mb-12" v-if="appointmentDetail.auditInfoDto">
        <p class="m-p-16 title m-c-191A26-40">审批流程</p>
        <div class="m-p-16">
          <template>
            <MSteps position="center">
              <MStep :ready="true">
                <div class="m-fb">
                  <p class="m-item-flex-1"
                    >{{ isMe(appointmentDetail.auditInfoDto) }}<span class="m-ml-8 m-c-999999">发起审批</span></p
                  >
                  <p class="m-c-999999 m-right">{{
                    timeFormatNew(appointmentDetail.auditInfoDto.gmtCreate, 'MM-DD hh:mm')
                  }}</p>
                </div>
              </MStep>
              <template v-if="appointmentDetail.auditInfoDto && appointmentDetail.auditInfoDto.jobNodeMemberDtoList">
                <template v-for="(item, index) in appointmentDetail.auditInfoDto.jobNodeMemberDtoList">
                  <!-- 撤销和拒绝的时候，审批中和未轮到都不显示 -->
                  <MStep
                    class=" m-lh-30"
                    :ready="!!item.status"
                    v-if="!([4, 2].includes(appointmentDetail.auditInfoDto.status) && [0, 1].includes(item.status))"
                    :key="index"
                  >
                    <div class="m-fb">
                      <p class="m-item-flex-1"
                        >{{ isMe(item) }}
                        <template v-if="item.status">
                          <span class="m-ml-8" :class="APPROVAL_AUDIT_MAP[item.status].class">{{
                            APPROVAL_AUDIT_MAP[item.status].text
                          }}</span>
                        </template>
                      </p>
                      <p class="m-c-999999  m-right" v-if="item.status && item.status !== 1">{{
                        timeFormatNew(item.gmtModify, 'MM-DD hh:mm')
                      }}</p>
                    </div>
                  </MStep>
                </template>
              </template>
              <MStep class="m-h-64 m-lh-64" :ready="true" v-if="appointmentDetail.auditInfoDto.status === 4">
                <div class="m-fb">
                  <p class="m-w-300"
                    >{{ isMe(appointmentDetail.auditInfoDto, 2) }}<span class="m-ml-8 m-c-999999">撤销审批</span></p
                  >
                  <p class="m-c-999999">{{
                    timeFormatNew(appointmentDetail.auditInfoDto.gmtModify, 'YYYY-MM-DD hh:mm:ss')
                  }}</p>
                </div>
              </MStep>
            </MSteps>
          </template>
        </div>
      </div>
    </div>
    <div
      class="footer m-p-12-0 m-p-0-16 m-fb-center-start m-bg-FFFFFF"
      slot="footer"
      v-if="
        appointmentDetail.auditInfoDto &&
          (appointmentDetail.auditInfoDto.status === 1 || appointmentDetail.auditInfoDto.status === 5)
      "
    >
      <MButton type="primary" :simple="true" class="m-mr-16 m-w-128" @click="handlerDealAudit(reserveId, 0)"
        >拒绝</MButton
      >
      <MButton type="primary" class="m-w-128" @click="handlerDealAudit(reserveId, 1)">同意</MButton>
    </div>
  </div>
</template>

<script>
import { APPROVAL_AUDIT_MAP } from '@/utils/constUtils'
import { timeFormatNew } from '@/utils/comUtils'
import { saveAs } from 'file-saver'
import UTransition from '@/components/common/uTransition/uTransition'
import status_1 from '@/assets/imgs/meeting/status_1.png'
import status_2 from '@/assets/imgs/meeting/status_2.png'
import status_3 from '@/assets/imgs/meeting/status_3.png'
import status_4 from '@/assets/imgs/meeting/status_4.png'
import status_0 from '@/assets/imgs/meeting/status_0.png'
import { web } from '@/mixin'
import { mapGetters } from 'vuex'
export default {
  name: 'PageVenueAppointmentDetail',
  components: { UTransition },
  mixins: [web],
  data() {
    let { reserveId } = this.$route.query || {}
    return {
      timeFormatNew,
      appointmentDetail: {},
      statusType: {
        0: status_0,
        1: status_1,
        2: status_2,
        3: status_3,
        4: status_4
      },
      showDetail: false,
      reserveId,
      APPROVAL_AUDIT_MAP
    }
  },
  computed: {
    ...mapGetters({
      token: 'token'
    }),
    computedShowTime() {
      if (!this.appointmentDetail.reserveTime) return ''
      return this.appointmentDetail.reserveTime.replace(/-/g, '.').replace(/、/g, '<br>')
    },
    computedMemberName() {
      console.log(this.appointmentDetail.participant, 'this.appointmentDetail.participant')
      if (!this.appointmentDetail.participant || !this.appointmentDetail.participant.length) return ''
      let deptDtoList = this.appointmentDetail.participant.filter(it => it.type === 1)
      let memberDtoList = this.appointmentDetail.participant.filter(it => it.type === 2)
      return `${deptDtoList.map(it => it.name).join('、')}${
        deptDtoList.length && memberDtoList.length ? '、' : ''
      }${memberDtoList.map(it => it.name).join('、')}`
    }
  },
  methods: {
    async handlerDownloadenClosure(item) {
      this.$httpPost('apiCommonDownloadFile', {
        url: item.picUrl
      })
        .then(res => {
          saveAs(res, item.fileName)
        })
        .catch(err => {
          console.log('err', err)
        })
    },
    // 去详情
    handlerToDetail() {
      this.$router.push({
        path: '/venue/detail',
        query: {
          spaceResourceId: this.appointmentDetail.resourceId,
          spaceArchivesId: this.appointmentDetail.spaceArchivesId
        }
      })
    },
    // 取消预约
    async handlerDealAudit(row, type) {
      if (type === 1) {
        this.handlerToCancel(row, type)
        return
      }
      let _that = this
      this.$Dialog({
        type: 'confirm',
        title: '审批拒绝',
        content: '确认拒绝当前的审批吗？',
        cancelBtn: {
          text: '取消',
          color: '#191A26'
        },
        confirmBtn: '确认',
        $events: {
          cancel() {},
          confirm() {
            _that.handlerToCancel(row, type)
          }
        }
      }).show()
    },
    handlerToCancel(reserveId, type) {
      let _postData = {
        reserveId: reserveId,
        status: type // 取消状态为6
      }
      this.$httpPost('apiDoAudit', _postData)
        .then(() => {
          setTimeout(() => {
            this.$Toast({
              type: 'success',
              content: '操作成功'
            }).show()
          }, 200)
          this.fetchGetInitiatedReserveDetail()
        })
        .finally(() => {})
    },
    // 审批人是否是当前用户
    isMe(member) {
      if ((member.startMemberId || member.memberId) === this.token.memberId) {
        return '我'
      } else {
        return member.startMemberName || member.memberName
      }
    },
    /** 预约详情 */
    fetchGetInitiatedReserveDetail() {
      this.$httpPost('apiInitiatedReserveDetail', {
        reserveId: this.reserveId
      })
        .then(_res => {
          console.log(_res)
          this.appointmentDetail = _res || {}
        })
        .finally(() => {})
    }
  },
  mounted() {
    this.fetchGetInitiatedReserveDetail()
    console.log(this.appointmentDetail, 'appointmentDetail')
  }
}
</script>
<style scoped lang="scss">
.PageAppointmentRecordDetails {
  .scroll-box {
    overflow-y: auto;
  }
  .title {
    border-bottom: 1px solid #e8e8e8;
  }
  .top-box {
    position: relative;
    .status-img {
      width: 100px;
      position: absolute;
      right: 16px;
      top: 16px;
      z-index: 99;
    }
  }
  .md-step {
    ::v-deep .van-step__icon--active {
      display: block;
      width: 5px !important;
      height: 5px;
      border-radius: 50%;
      background-color: #003f88;
    }
    .van-step--vertical:not(:last-child)::after {
      border: 0 none;
    }
    ::v-deep .van-step__title {
      color: #333 !important;
    }
  }
}
</style>
<style>
html,
body {
  min-width: auto;
}
</style>
